<template>
  <section class="timeline timeline_places" :class="{ mini: !mode }">
    <div class="timeline-scroll">
      <!-- Поиск -->
      <div class="timeline-header">
        <div class="title-switcher" :class="{open: switcher}" v-if="!showSearch">
          <div class="title-dropdown">
            <h2 class="timeline-title active" @click="switcher = !switcher">Места 
              <img src="@/assets/images/icons/arrow-down.svg" alt="">
            </h2>
            <router-link tag="h2" class="timeline-title" :to="{name: 'events'}">Ивенты</router-link>
          </div>
        </div>
        <div class="search" v-if="showSearch">
          <div class="input-search">
              <input type="search" placeholder="Поиск" v-model="search" @input="searchByTitle" ref="search">
              <img src="@/assets/images/icons/icon_search-b.svg" width="22px">
          </div>
        </div>
        <div class="search-buttons">
          <div class="search-icon" v-if="!showSearch" @click="changeState('sports')">
            <img src="@/assets/images/icons/filters.svg" width="24px" />
          </div>
          <div class="search-icon" v-if="!showSearch" @click="changeOpenSearch()">
            <img src="@/assets/images/icons/icon_search-b.svg" width="22px" />
          </div>
          <div class="search-close" v-if="showSearch" @click="changeOpenSearch()">
            <img src="@/assets/images/icons/icon_close.svg" width="22px" />
          </div>
        </div>
      </div>

      <!-- Фильтры -->
      <div class="timeline-filters">
        <div class="timeline-string">
          <div class="timeline-buttons">
            <div
              class="button"
              :class="{ active: getTypePlaces == 'my_places' }"
              @click="setType('my_places')"
            >
              Мои места
            </div>
            <!-- TODO: Любимые места -->
            <div
              class="button"
              :class="{ active: getTypePlaces == 'liked' }"
              @click="setType('liked')"
            >
              Любимые
            </div>
            <!-- <div class="button" :class="{active: hasActive('tomorow')}" @click="setTime('tomorow', 'time')">Завтра</div> -->
          </div>
        </div>

        <Sports :sports="getActiveSports" />
        <Info 
          @click.native="openAction()"
          :content="'Заработай, собирая тусовки в wildwood.online! 💸 🤙🏻'" 
          :description="'До 15 ноября'" 
          :button="{text: 'Подробнее'}" 
        />
      </div>

      <!-- Список постов -->
      <div class="timeline-body" v-if="!timelineLoader">
        <PostPlace v-for="place of places" :key="place.id" :place="place" />
        <div class="timeline-nothing" v-if="!places || places.length === 0">
          <p>Ничего не найдено 💩</p>
        </div>
      </div>
      <PseudoTimeline v-else />
    </div>

    <!-- Скнопка скрытия списка -->
    <div class="timeline-toggle">
      <div class="timeline-toggle__button" @click="mode = !mode">
        <p>{{ mode ? 'Скрыть' : 'Показать' }}</p>
      </div>
    </div>

    <div class="timeline-footer">
      <div class="timeline-add" @click="openNewPlace()">
        <p>Добавить место</p>
      </div>
    </div>

    <!-- Кнопка открытия карты на мобиле -->
    <div class="timeline-openmap" @click="openMap()">
      <font-awesome-icon icon="map-marker-alt" />
      <p>Карта</p>
    </div>
  </section>
</template>

<script>
import PostPlace from './PostPlace.vue'
import termsAction from "@/data/main/termsAction"

export default {
  props: {
    places: {
      type: Array,
      required: true,
    },
  },
  components: {
    PostPlace,
    Sports: () => import('@/components/Filters/Sports'),
    PseudoTimeline: () => import('@/components/Pseudo/PseudoTimeline'),
    Info: () => import('@/components/UI/Info'),
  },
  data() {
    return {
      page: 1,
      sports: this.getActiveSports || null,
      mode: true,
      date: null,
      switcher: false,
      open_search: false
    };
  },
  computed: {
    showSearch() {
      return this.search && this.search.length > 0 || this.open_search
    },
    search: {
      get () {
        return this.$store.state.filters.search_places
      },
      set (value) {
        this.$store.commit('setSearchPlaces', value)
      }
    },
    getActiveSports() {
      return this.$store.getters.getActiveSports;
    },
    getDate() {
      return this.$store.getters.getDate;
    },
    getFilters() {
      return this.$store.getters.getFilters;
    },
    getTypePlaces() {
      return this.$store.getters.getTypePlaces;
    },
    timelineLoader() {
      return this.$store.getters.timelineLoader;
    },
    getUser() {
      return this.$store.getters.getAuthUser
    }
  },
  methods: {
    openAction() {
      this.$store.dispatch('setModal', termsAction )
    },
    changeOpenSearch() {
      this.open_search = !this.open_search
      !this.open_search || this.search.length > 0
        ? (this.search = '', this.searchByTitle()) 
        : this.focusOnSearch()
    },
    focusOnSearch() {
      setTimeout(() => {
        let search = this.$refs.search;
        search ? search.focus() : ''
      }, 100)
    },
    setType(type) {
      this.getTypePlaces == type ? this.$store.dispatch('setTypePlaces', 'all') : this.$store.dispatch('setTypePlaces', type);
    },
    // setTime(filter, group) {
    //   let finded = this.getFilters.find((item) => item.group === group);
    //   let one = this.getFilters.find((item) => item.filter === filter);
    //   if (one) {
    //     one ? this.getFilters.splice(this.getFilters.indexOf(one), 1) : '';
    //   } else {
    //     finded ? this.getFilters.splice(this.getFilters.indexOf(finded), 1) : '';
    //     this.getFilters.push({ filter: filter, group: group });
    //   }
    //   this.$store.dispatch('setFilters', this.getFilters);
    // },
    hasActive(filter) {
      return this.getFilters.find((item) => item.filter == filter) ? true : false;
    },
    lazyLoad() {
      let timeline = document.querySelector('.timeline');
      timeline.addEventListener('scroll', () => {
        if (timeline.scrollTop + timeline.clientHeight >= timeline.scrollHeight) {
          this.page++;
          this.$store.dispatch('getEvents', {
            page: this.page,
            filters: this.getFilters,
            sports: this.getActiveSports,
          });
        }
      });
    },
    searchByTitle() {
      let search = this.search;
      if (search.length > 2 || search.length === 0) {
        let filters = this.getFilters;
        let finded = filters.find((filter) => filter.group === 'search');
        let filter = { filter: search, group: 'search' };
        finded ? filters.splice(filters.indexOf(finded), 1) : '';
        filters.push(filter);
        this.$store.dispatch('setFilters', filters);
      }
    },
    changeState(element) {
      this.$store.dispatch('changeState', { element: element, val: true });
    },
    openNewPlace() {
      this.getUser ? '' : this.$router.push({name: 'login'})
      this.$store.dispatch('setNewType', 'places');
      this.$store.dispatch('changeState', {element: 'workplace'});
    },
    openMap() {
      this.$store.dispatch('changeListPlaces', false);
      this.$store.dispatch('changeModePlaces', 'map');
    }
  },
  mounted() {
    this.lazyLoad();
  },
};
</script>
